import { styled } from '@glitz/react';
import * as React from 'react';
import { createMaxSmallViewportDecorator } from 'webapp/viewport';
import Link from '../Link';

type PropType = {
  progress: number;
  axis?: 'x' | 'y';
};

export const CarouselProgress = styled(({ progress, axis = 'x' }: PropType) => {
  if (progress === undefined) {
    return null;
  }

  const verticalStyleDecorator = styled({ width: 1 });
  const horizontalStyleDecorator = styled({ height: 1 });
  const axisDecorator = axis === 'x' ? horizontalStyleDecorator : verticalStyleDecorator;
  const progressDecorator = styled(axis === 'x' ? { width: `calc(${progress}%)` } : { height: `calc(${progress}%)` });

  return (
    <ProgressBackground css={axisDecorator}>
      <ProgressSlider css={styled(axisDecorator, progressDecorator)} />
    </ProgressBackground>
  );
});

const ProgressBackground = styled.div(
  createMaxSmallViewportDecorator({
    margin: { top: t => t.spacing.m },
  }),
  {
    marginTop: t => t.spacing.l,
    position: 'relative',
    backgroundColor: t => t.borderColor,
    borderRadius: 5,
  },
);

const ProgressSlider = styled(Link, {
  position: 'absolute',
  backgroundColor: t => t.darkGrey,
  borderRadius: 5,
  left: 0,
});
